import React from 'react';
import Swal from 'sweetalert2';
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import Option from './SelectRelacion';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        datosCargados: false,
        ItemTabla: [],
        Tabla: [],
        Campos: [],
        Relaciones: [],
        Titulo: 'Cargando..',
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar el registro?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("master/borrar/" + this.props.match.params.id + "/" + id)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListarTabla(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };
    VerRegistros = (ide) => {
        console.log('vre:' + ide);
        authAxios.get("master/ver/" + this.props.match.params.id + "/" + ide)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                let lista = datosRespuesta.data.data;
                document.getElementById('NOMBRE').value = lista.NOMBRE
                let campos = datosRespuesta.data.modelo
                campos.map((item, i) => (
                    document.getElementById(item.nombre_campo).value = lista[item.nombre_campo]
                ))
            })
            .catch(console.log);
    };
    limpiarformulario() {
        document.getElementById("form_registro").reset();
    }
    save() {
        Swal.showLoading();
        let form = document.getElementById('form_registro');
        let formData = new FormData(form);
        authAxios.post("master/registrar/" + this.props.match.params.id, formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.fire(
                        'Registro!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    document.getElementById("form_registro").reset();
                    this.ListarTabla(1)
                } else {
                    Swal.close();
                    Swal.fire(
                        'Registro!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    ListarTabla(page) {
        Swal.showLoading();
        let form = document.getElementById('buscador');
        let formData = new FormData(form);
        console.log(formData);
        authAxios.post("master/index/" + this.props.match.params.id + "?page=" + page, formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                Swal.close();
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                //document.getElementById('tablamaster').innerHTML = datosRespuesta.data.modelo[0].nombre_titulo;
                this.setState({ datosCargados: true, Titulo: datosRespuesta.data.titulo, Relaciones: datosRespuesta.data.relaciones, Campos: datosRespuesta.data.campos, Tabla: datosRespuesta.data.modelo, ItemTabla: datosRespuesta.data.data.data, pagina: datosRespuesta.data.data.total, ultimo: datosRespuesta.data.data.last_page, actual: datosRespuesta.data.data.current_page });
            })
            .catch(console.log);
        //window.location.href = '/'; window.localStorage.clear();
    }
    componentDidMount() {
        console.log('test' + this.props.match.params.id);
        this.ListarTabla(1);
    }
    render() {
        const { Relaciones, pagina, ultimo, actual, Tabla, Campos, Titulo } = this.state;
        return (
            <div>
                <div className="content">
                    <div className="content-wrapper">
                        <div className="content">
                            <div className="container-fluid">
                                <br />
                                <div className="card">
                                    <div className="card-header">

                                        <button
                                            type="button"
                                            className="btn btn-success btn-sm"
                                            data-bs-toggle='modal' data-bs-target="#FormularioModal"
                                            onClick={() => this.limpiarformulario()}
                                        >
                                            <FontAwesomeIcon icon={faPlus} /> Nuevo Registro
                                        </button>
                                    </div>
                                    <div className="card-body">
                                        <h4>Lista <span id="tablamaster"></span> {Titulo}</h4>
                                        <hr />

                                        <div className="row">

                                            <table className="table table-hover table-condensed table-sm">



                                            </table>
                                            <form id="buscador">
                                                <table className="table table-hover table-condensed table-sm">
                                                    <thead className="thead-inverse">
                                                        <tr>
                                                            {
                                                                Tabla.map((row) => (
                                                                    <th className="align-middle" key={row.id}>{row.nombre_titulo}</th>
                                                                ))
                                                            }
                                                            <th>OPCIONES</th>
                                                        </tr>

                                                        <tr>
                                                            {
                                                                Tabla.map((row) => (
                                                                    <td className="align-middle" key={row.id}><input type="text" id={'BUS_' + row.nombre_campo} name={'BUS_' + row.nombre_campo} placeholder={row.nombre_titulo} className="form-control form-control-sm" /></td>
                                                                ))
                                                            }
                                                            <td><button id="bt" name="bt" type="button" className="btn btn-secondary btn-sm" onClick={() => this.ListarTabla(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button></td>
                                                        </tr>

                                                    </thead>

                                                    <tbody>



                                                        {
                                                            Campos.map((ITEM, i) => (
                                                                <tr key={i}>
                                                                    {
                                                                        Tabla.map((row, i) => (
                                                                            <td key={row.id}>{ITEM[i]} </td>
                                                                        ))
                                                                    }
                                                                    <td>
                                                                        <div className="btn-group" role="group" aria-label="">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-primary btn-sm"
                                                                                data-bs-toggle='modal' data-bs-target="#FormularioModal"
                                                                                onClick={() =>
                                                                                    this.VerRegistros(ITEM[0])
                                                                                }
                                                                            >
                                                                                <FontAwesomeIcon icon={faEdit} />
                                                                            </button>
                                                                            &nbsp;&nbsp;
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-danger btn-sm"
                                                                                onClick={() =>
                                                                                    this.borrarRegistros(ITEM[0])
                                                                                }
                                                                            >
                                                                                <FontAwesomeIcon icon={faTrashAlt} />
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table></form>

                                        </div>
                                        <nav aria-label="Page navigation example">
                                            <ul className="pagination">
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarTabla(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarTabla(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                                {(() => {
                                                    let p = [];
                                                    p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.ListarTabla(actual)}>{actual}</a></li>);
                                                    return p;
                                                })()}
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarTabla(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarTabla(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                            </ul>
                                        </nav>
                                    </div>
                                    <div className="card-footer text-muted">
                                        <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="FormularioModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="nuevoPacienteSubLabel" aria-hidden="true">
                    <div className="modal-dialog  modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title" id="permisoRolesModalLabel">Formulario de registro</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <form id="form_registro">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">

                                                <div className="row g-3">
                                                    {
                                                        Tabla.map((row, i) => (
                                                            i !== 0 ?

                                                                <div className="col-md-4">
                                                                    <label htmlFor="cedula">{row.nombre_titulo}</label>
                                                                    {

                                                                        row.trae_tabla === null ?
                                                                            <input className={"form-control form-control-sm"} type="text" name={row.nombre_campo} id={row.nombre_campo} placeholder={row.nombre_titulo} />
                                                                            :

                                                                            <Option t={row.trae_tabla} v={row.trae_value} c={row.trae_campo} nombre_input={row.nombre_campo} />


                                                                    }

                                                                </div>
                                                                :
                                                                <input className={"form-control form-control-sm"} type="hidden" name={row.nombre_campo} id={row.nombre_campo} placeholder={row.nombre_titulo} />
                                                        ))
                                                    }
                                                </div>
                                            </div>

                                        </div>

                                        <hr />

                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-primary btn-sm" onClick={() => this.save()}>Guardar Registro</button>
                                            <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">Cerrar</button>
                                        </div>

                                    </div>
                                    <hr />
                                </form>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        );
    }
}

export default Listar;